import { IStore } from "helpers";
import { createSlice } from "@reduxjs/toolkit";

export const farmerAccountReducer = createSlice({
  name: "farmerAccount store",
  initialState: {
    createSuccessfully: false,
    producerNameUpdate: "",
  },
  reducers: {
    setCreateSuccessfully: (state, action) => {
      state.createSuccessfully = action.payload;
    },
    setProducerNameUpdate: (state, action) => {
      state.producerNameUpdate = action.payload;
    },
  },
});
export const { setCreateSuccessfully, setProducerNameUpdate } = farmerAccountReducer.actions;

export const getCreateSuccessfully = (state: IStore) => state.farmerAccount.createSuccessfully;
export const getProducerNameUpdate = (state: IStore) => state.farmerAccount.producerNameUpdate;

export default farmerAccountReducer.reducer;
